export * from './recovery-pass-token.component';
